module.exports = __webpack_public_path__ + "img/pmt.800eeff2.png";